import React from "react";
import { Client } from "../requests";
import NewClientForm from "./NewClientForm";
import { useNavigate } from "react-router-dom";

const NewClientPage = (props) => {

  const navigate = useNavigate()

  const createClient = (params) => {
    Client.create(params).then((client) => {
      navigate(`/clients/${client.id}`);
    });
  };


  return (
    <>
      <div>
        <h1 className="text-center">New client page</h1>
        <NewClientForm
          createClient={createClient}
        />
      </div>
    </>
  );
};

export default NewClientPage;
